<template>
  <div>
    <v-toolbar dense
               src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-tabs
      background-color="indigo"
      fixed-tabs
      dark
    >
      <v-tab>
        <v-icon class="mr-3">mdi-receipt</v-icon>
        Platby
      </v-tab>
      <v-tab-item>
        <v-tabs
          fixed-tabs
          background-color="primary"
          dark
        >
          <v-tab>
            <v-icon class="mr-3">mdi-credit-card-outline</v-icon>
            Platební brány
          </v-tab>
          <v-tab-item>
            <PaymentGates></PaymentGates>
          </v-tab-item>
          <v-tab>
            <v-icon class="mr-3">mdi-information-variant</v-icon>
            Fakturační údaje
          </v-tab>
          <v-tab-item>
            <BillingInformation></BillingInformation>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
      <v-tab>
        <v-icon class="mr-3">mdi-account-group</v-icon>
        Uživatelé
      </v-tab>
      <v-tab-item>
        <v-tabs
          fixed-tabs
          background-color="succes"
          dark
        >
          <v-tab>
            <v-icon class="mr-3">mdi-head-cog-outline</v-icon>
            Administrátoři
          </v-tab>
          <v-tab-item>
            <Admins></Admins>
          </v-tab-item>
          <v-tab>
            <v-icon class="mr-3">mdi-car</v-icon>
            Řidiči
          </v-tab>
          <v-tab-item>
            <Drivers></Drivers>
          </v-tab-item>
          <v-tab>
            <v-icon class="mr-3"></v-icon>
            Výdejci
          </v-tab>
          <v-tab-item>
            <Dispensers></Dispensers>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
      <v-tab>
        <v-icon class="mr-3">mdi-cog-outline</v-icon>
        Systém
      </v-tab>
        <v-tab-item>
        <v-tabs
          fixed-tabs
          background-color="primary"
          dark
        >
          <v-tab>
            <v-icon class="mr-3">mdi-food</v-icon>
            Typy jídla
          </v-tab>
          <v-tab-item>
            <FoodTypes></FoodTypes>
          </v-tab-item>
          <v-tab>
            <v-icon class="mr-3">mdi-food-variant-off</v-icon>
            Alergeny
          </v-tab>
          <v-tab-item>
            <Allergens></Allergens>
          </v-tab-item>
          <v-tab>
            <v-icon class="mr-3">mdi-home-city</v-icon>
            Městské části
          </v-tab>
          <v-tab-item>
            <Districts></Districts>
          </v-tab-item>
          <v-tab>
            <v-icon class="mr-3">mdi-bell-outline</v-icon>
            Upozornění
          </v-tab>
          <v-tab-item>
            <Alerts></Alerts>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import Alerts from '../../components/admin/settings/Alerts'
import Districts from '../../components/admin/settings/Districts'
import FoodTypes from '../../components/admin/settings/FoodTypes'
import Drivers from '../../components/admin/settings/Drivers'
import Admins from '../../components/admin/settings/Admins'
import BillingInformation from '../../components/admin/settings/BillingInformation'
import PaymentGates from '../../components/admin/settings/PaymentGates'
import Allergens from '../../components/admin/settings/Allergens'
import Dispensers from '../../components/admin/settings/Dispensers'
export default {
  name: 'Settings',
  components: { Dispensers, Allergens, PaymentGates, BillingInformation, Admins, Drivers, FoodTypes, Districts, Alerts },
  methods: {
    initialize () {
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
